import React from "react";
import {Box, Typography} from "@mui/material";

import Impressum from "./Impressum";

import {SIGNIN_BASE_LAYOUT_TRANSLATION} from "./SignInAppTranslation.common.de";
import {lxStyled, Parent, useLxTranslations} from "@lxo-blocks/react";
import LexofficeLogo from "./images/LexofficeLogo";

const PREFIX = 'DeviceManagerBaseLayout';
const classes = {
    headline: `${PREFIX}-headline`,
    subheadline: `${PREFIX}-subheadline`
}
const BaseLayoutContainer = lxStyled(Box)(({theme}) => ({
    [`.${classes.headline}`]: {
        color: `${theme.palette.text.primary}`,
        fontSize: "32px"
    }
}));

interface SignInBaseLayoutProps extends Parent {
    headline_i18n: any
    subtitle_i18n: any
}


export default function SignInBaseLayout(props: SignInBaseLayoutProps) {
    const {t} = useLxTranslations(SIGNIN_BASE_LAYOUT_TRANSLATION);
    return (
        <>
            <Box style={{minHeight: "calc(100vh - 30px)"}}>
                <BaseLayoutContainer mx={2} sx={{margin: "0 auto", maxWidth: "650px"}}>
                    <LexofficeLogo sx={{justifyContent: "center", paddingTop: "30px", paddingBottom: "20px"}}/>
                    <Typography component="h2" variant="h2" align={"center"}
                                className={`${classes.headline}`}>
                        {t(props.headline_i18n)}
                    </Typography>
                    <Typography component="div" variant="body2" align={"center"}
                                sx={{marginTop: "20px", marginBottom: "20px"}}>
                        {t(props.subtitle_i18n)}
                    </Typography>
                    {t(props.subtitle_i18n) === "" && <Box sx={{marginBottom: "60px"}}/>}

                </BaseLayoutContainer>
                <Box mx={2} sx={{margin: "0 auto", maxWidth: "544px"}}>
                    {props.children}
                </Box>
            </Box>
            <Box justifyContent="center">
                <Impressum/>
            </Box>
        </>
    );
}
